
<template>
  <div class="staisdeteilpage">
    <!-- 数据请求渲染使用 -->
    <!-- <star  v-for="item in starGradeArr" :key="item['index']" :grade="item.stargrade" :id="item.id"  @gradeDtae='gradeDtae'></star>-->
    <div class="evabox" v-for="item in list">
      <p class="evabigtitle">{{item.Name}}</p>
      <div class="evalcon" v-for="model in item.Dettails">
        <p class="pl22">{{model.Name}}</p>
        <div class="star pl22">
          <star :key="model.GUID" :grade="model.Fraction" :id="model.GUID" @gradeDtae="gradeDtae"></star>
        </div>
        <div class="gradesfont">{{model.startValue}}</div>
      </div>
    </div>
    <div class="evabox">
      <div class="pl22">
        <p class="lh">您的其它意见或建议：</p>
        <div class="mr">
          <textarea name rows="6" class="area" v-model="proposal"></textarea>
        </div>
        <p class="lh">联系电话：</p>
        <div class="mr">
          <input type="text" class="ipttext" v-model="phone">
        </div>
      </div>
    </div>
    <div class="submit" @click="addInvestigation">
      <span>提交</span>
    </div>
  </div>
</template>



<script>
import star from "./star"; //引入星级评分组件
import weui from "weui.js";
import {
  GetInvestigationByHosID,
  AddInvestigation
} from "@/services/getData.js";
export default {
  name: "satisfaction-deteil",
  data() {
    return {
      hosid: this.$route.query.hosid,
      visitID: this.$route.query.visitID,
      list: {},
      phone: "",
      proposal: "",
      startValue: "",
      startcom: ["非常不满意", "不满意", "一般", "满意", "非常满意"],
      $dialog: []
    };
  },
  created: function() {
    this.getInvestigationByHosID();
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  components: {
    star
  },
  methods: {
    addInvestigation() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      AddInvestigation(
        this.visitID,
        JSON.stringify(this.list),
        this.proposal,
        this.phone
      ).then(response => {
        loading.hide();
        if (response.data.Result) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "评价成功"
          });
          this.$router.back(-1);
        } else {
        }
      });
    },
    gradeDtae(val) {
      let that = this;
      that.list.forEach(e => {
        e.Dettails.forEach(x => {
          if (x["GUID"] == val["GUID"]) {
            x.Fraction = val.gradetemp;
            that.startcom.forEach((item, index) => {
              if (index + 1 == val.gradetemp) {
                x.startValue = item;
              }
            });
          }
        });
      });
    },
    getInvestigationByHosID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetInvestigationByHosID(this.hosid).then(response => {
        loading.hide();
        if (response.data) {
          this.list = response.data;
        } else {
        }
      });
    }
  }
};
</script>
<style>
.staisdeteilpage {
  width: 100%;
  height: auto;
}

.staisdeteilpage .evabox {
  background: white;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 0.2rem;
}

.staisdeteilpage .evabox .evabigtitle {
  text-align: center;
  height: 0.6rem;
  line-height: 0.6rem;
  border-bottom: 0.01rem solid #dddddd;
}

.staisdeteilpage .evabox .evalcon {
  padding: 0.25rem 0;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #dddddd;
  position: relative;
}

.staisdeteilpage .evabox .pl22 {
  box-sizing: border-box;
  padding-left: 0.22rem;
}

.staisdeteilpage .evabox .evalcon .gradesfont {
  position: absolute;
  left: 3.4rem;
  bottom: 0.29rem;
}

.staisdeteilpage .mr {
  margin-right: 0.22rem;
}

.staisdeteilpage .area {
  height: 1.4rem;
  background: rgba(242, 242, 242, 1);
  border: 1px solid rgba(220, 220, 220, 1);
  width: 100%;
}

.staisdeteilpage .lh {
  line-height: 0.62rem;
}

.staisdeteilpage .ipttext {
  height: 0.6rem;
  background: rgba(242, 242, 242, 1);
  border: 1px solid rgba(220, 220, 220, 1);
  width: 100%;
  margin-bottom: 0.25rem;
}

.staisdeteilpage .submit {
  flex: 1;
  background-color: #1592e4;
  height: 0.8rem;
  margin: 0.2rem;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  color: #fffefe;
  text-align: center;
  line-height: 0.8rem;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/satisfaction/satisfaction-deteil.vue